import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

// Thematic Area
export const getThematicAreas = async (params: any) => {
  return api.get(url.GET_THEMATIC_AREAS, params);
};
export const getThematicArea = async (id: number) => {
  return api.get(`${url.GET_THEMATIC_AREA}/${id}`);
};
export const addThematicArea = async (data: any) => {
  return api.create(url.ADD_THEMATIC_AREA, data);
};
export const updateThematicArea = async (id: number, data: any) => {
  return api.put(`${url.UPDATE_THEMATIC_AREA}/${id}`, data);
};
export const deleteThematicArea = async (id: number) => {
  return api.delete(`${url.DELETE_THEMATIC_AREA}/${id}`);
};

// Sector
export const getSectors = async (params: any) => {
  return api.get(url.GET_SECTORS, params);
};
export const getSector = async (id: number) => {
  return api.get(`${url.GET_SECTOR}/${id}`);
};
export const addSector = async (data: any) => {
  return api.create(url.ADD_SECTOR, data);
};
export const updateSector = async (id: number, data: any) => {
  return api.put(`${url.UPDATE_SECTOR}/${id}`, data);
};
export const deleteSector = async (id: number) => {
  return api.delete(`${url.DELETE_SECTOR}/${id}`);
};
